import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'dark' | 'light' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
}

const variantStyles: Record<string, string> = {
  dark: 'bg-stone-900 text-white',
  light: 'bg-stone-100 text-stone-700 border border-stone-200',
  success: 'bg-green-50 text-green-800 border border-green-200',
  warning: 'bg-amber-50 text-amber-800 border border-amber-200',
  error: 'bg-red-50 text-red-800 border border-red-200',
};

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'dark',
  size = 'sm',
}) => (
  <span
    className={`inline-flex items-center font-bold uppercase tracking-widest ${
      size === 'sm' ? 'text-[8px] px-2 py-0.5' : 'text-[10px] px-3 py-1'
    } ${variantStyles[variant]}`}
  >
    {children}
  </span>
);

export default Badge;
